export default __webpack_public_path__ + "static/media/kyr-logo-v2.e9451b0d.svg";